"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorMode = exports.ColorModeProvider = exports.ColorModeContext = exports.useColorModeState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const defaultColorMode = 'light';
const localStorageKey = 'tm-color-mode';
function useColorModeState() {
    const [colorMode, setColorMode] = (0, react_1.useState)(() => {
        try {
            const savedColorMode = localStorage.getItem(localStorageKey);
            return savedColorMode === 'light' || savedColorMode === 'dark' ? savedColorMode : defaultColorMode;
        }
        catch (error) {
            return defaultColorMode;
        }
    });
    return (0, react_1.useMemo)(() => ({
        enabled: true,
        colorMode,
        isDark: colorMode === 'dark',
        isLight: colorMode === 'light',
        toggleColorMode: () => setColorMode(prevColorMode => {
            const nextColorMode = prevColorMode === 'light' ? 'dark' : 'light';
            try {
                localStorage.setItem(localStorageKey, nextColorMode);
            }
            catch (error) { }
            return nextColorMode;
        }),
    }), [colorMode]);
}
exports.useColorModeState = useColorModeState;
exports.ColorModeContext = (0, react_1.createContext)({
    enabled: false,
    colorMode: defaultColorMode,
    isDark: false,
    isLight: true,
});
function ColorModeProvider({ children }) {
    const value = useColorModeState();
    return (0, jsx_runtime_1.jsx)(exports.ColorModeContext.Provider, { value: value, children: children });
}
exports.ColorModeProvider = ColorModeProvider;
function useColorMode() {
    return (0, react_1.useContext)(exports.ColorModeContext);
}
exports.useColorMode = useColorMode;
